import React, { useCallback } from 'react';
import { ErrorFallbackProps, useStrictInstance } from '@funtech-int/rival-react';
import { resourcesRef } from '@funtech-int/rival';

export function withResourceFreeError<P extends ErrorFallbackProps>(
    Component: React.ComponentType<P>
) {
    function WrappedComponent(props: P) {
        const resources = useStrictInstance(resourcesRef);

        const { resetError } = props;

        const resetErrorHandler = useCallback(() => {
            resources.free();
            resetError?.();
        }, [resetError, resources]);

        return <Component {...props} resetError={resetErrorHandler} />;
    }

    WrappedComponent.displayName = `withResourceFreeError(${
        Component.displayName ?? Component.name
    })`;

    return WrappedComponent;
}
